import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const HomeIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.37305 14.9V25.7187C3.37305 26.427 3.94601 26.9955 4.64981 26.9955H23.8148C24.5231 26.9955 25.0916 26.4225 25.0916 25.7187V9.8877"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.433 11.8277L14.2323 1L1.56836 11.8277"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4883 4.27539V7.74025"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0293 14.7556H17.4944C18.1982 14.7556 18.7711 15.3286 18.7711 16.0324V26.9999H9.74805V16.0324C9.74805 15.3286 10.321 14.7556 11.0248 14.7556H11.0293Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3236 22.0056C12.7472 22.0056 13.0906 21.6622 13.0906 21.2386C13.0906 20.8151 12.7472 20.4717 12.3236 20.4717C11.9 20.4717 11.5566 20.8151 11.5566 21.2386C11.5566 21.6622 11.9 22.0056 12.3236 22.0056Z"
        fill="#00B927"
      />
    </svg>
  );
};

export default HomeIcon;
